import { Request } from 'api';
import { AxiosResponse } from 'axios';

type ReturnType = Promise<AxiosResponse<void>>;

const removeSharedUserForOrganization = (id: string, userId: string): ReturnType => {
    return Request.delete(`/organizations/${id}/users/${userId}`);
};

export default removeSharedUserForOrganization;
